// Stale-after-save sweep (PR #648) — shared query keys for the staff deal
// staging surfaces (queue page list + review page detail).

import type { QueryClient } from "@tanstack/react-query";
import { dealKeys } from "@/hooks/deals/useDeals";

export const stagingKeys = {
  all: ["deal-staging"] as const,
  list: (filters: Record<string, unknown>) =>
    [...stagingKeys.all, filters] as const,
  detail: (id: string) => ["deal-staging-detail", id] as const,
};

/** Create Deal success path: refresh the staging caches AND the deal
 * pipeline lists so the imported deal appears without a manual refresh.
 * Exported as a helper so the invalidation test doesn't have to render the
 * (heavy) review page. */
export function invalidateAfterImport(
  queryClient: QueryClient,
  submissionId: string,
) {
  void queryClient.invalidateQueries({ queryKey: stagingKeys.detail(submissionId) });
  void queryClient.invalidateQueries({ queryKey: stagingKeys.all });
  void queryClient.invalidateQueries({ queryKey: dealKeys.lists() });
}
